<template>
  <!-- 验证码 -->
  <div class="big-box">
    <input ref="input" v-model.trim="code" @blur="lose" type="number" />
    <div @click="handleFocus" class="box">
      <div v-for="(item,index) in loopDiv" :key="index" class="item " ref="code" :class="{active:code[index]}">{{code[index]}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "baseCode",
  props: {
    // 控制验证码格子数量/输入长度
    size: {
      type: [String, Number],
      default: 4
    }
  },
  data() {
    return {
      code: "",
      current: 0
    }
  },
  watch: {
    code() {
      this.code = this.code.toString().slice(0, this.maxLength);
      this.current = this.code.length;
      this.$emit("getCode", this.code);
    }
  },
  computed: {
    // input最大长度
    maxLength() {
      return typeof this.size == "number" ? this.size : Number(this.size);
    },
    loopDiv() {
      return new Array(this.maxLength);
    },
  },
  methods: {
    handleFocus() {
      // 点击任意显示格聚焦input框
      this.$refs.input.focus();
      this.$refs.code.forEach((item) => {
        item.style.borderColor = "#0078fc"
      })
      let len = this.code.length;
      // 如果已经输满，点击则聚焦在最后一个字符
      if (len == this.maxLength) {
        this.current = this.code.length - 1;
      } else {
        this.current = this.code.length;
      }
    },
    //input失焦触发，等于-1防止出现size符合偶然情况，失焦后又聚焦某一div
    lose() {
      this.current = -1;
      this.$refs.code.forEach((item) => {
        item.style.borderColor = "#999999"
      })
    }
  },
  mounted() {
    // this.handleFocus();
  }
}
</script>

<style lang="less" scoped>
@keyframes cursor {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.big-box {
  margin: 18px auto 30px;
}
input {
  position: absolute;
  transform: scale(0);
}
.box {
  box-sizing: border-box;
  padding-left: 44px;
  display: flex;
  // justify-content: space-around;
  cursor: text;
}
.item {
  margin-right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 34px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
}
.item.active::before {
  content: "";
  position: absolute;
  bottom: 7px;
  left: 11px;
  height: 1px;
  width: 12px;
  background: #333333;
}
.animation {
  animation: cursor 1s infinite;
}
</style>